import type { MessageResponse } from '../../../api';
import { author_type, message_type } from './const';

export const messageBoxVariantClasses: Record<author_type, string> = {
  [author_type.USER]: 'mr-sm border-buttonLight',
  [author_type.ASSISTANT]: 'ml-sm bg-buttonLight border-transparent',
  [author_type.VALIDATOR]: 'ml-sm bg-red-100 border-red-400 text-red-800',
};

export const getMessageBoxVariantClasses = (type: string | undefined): string =>
  messageBoxVariantClasses[type as author_type] ??
  messageBoxVariantClasses[author_type.ASSISTANT];

export const filterParallelSTTContent = (text: string): string => {
  if (!text) return text;

  const regex = /\[\$hideTxt.*?endHideTxt\$\]/gs;
  return text.replace(regex, '').trim();
};

export const filterMessagesWithInterruptions = (
  messages: MessageResponse[],
  showInterruptions: boolean,
  showParallelSTT: boolean = true
): MessageResponse[] => {
  const groupById = new Map<string, MessageResponse>();
  for (const msg of messages) {
    groupById.set(msg?.id as string, msg);
  }

  let filtered = Array.from(groupById.values());

  if (!showInterruptions) {
    const fullVoice = new Set(
      filtered
        .filter(m => m.message_type === message_type.VOICE)
        .map(m => m.timestamp!)
    );

    filtered = filtered.filter(
      m =>
        !(
          m.message_type === message_type.VOICE_INTERRUPTED &&
          fullVoice.has(m.timestamp!)
        )
    );
  }

  if (!showParallelSTT) {
    filtered = filtered.map(msg => ({
      ...msg,
      message_text: filterParallelSTTContent(msg.message_text || ''),
    }));
  }

  return filtered.sort(
    (a, b) =>
      new Date(a.timestamp!).getTime() - new Date(b.timestamp!).getTime()
  );
};
